/**
 * FlashAlerts is the map normally from the editorStore.flashAlerts
 */
export type FlashAlerts = Map<string, FlashAlertData>;
type ToneOptions = "neutral" | "warn" | "critical" | "positive" | "brand-default";
export class FlashAlertData {
  message: string;
  tone: ToneOptions;
  id: string;
  constructor(message: string, tone: ToneOptions) {
    this.message = message;
    this.tone = tone;
    this.id = String(Math.random());
  }
}

export class FlashAlertManager {
  static create(data: FlashAlertData, flashes: FlashAlerts, timer: number = 0) {
    flashes.set(data.id, data);

    if (timer) {
      setTimeout(() => FlashAlertManager.close(data.id, flashes), timer);
    }
  }

  static close(id: string, flashes: FlashAlerts) {
    flashes.delete(id);
  }
}
